import React from 'react';
import './App.css';
import SafeIcon from './common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiCheck,FiStar,FiZap,FiTrendingUp}=FiIcons;

function App() {
const pricingTiers=[ 
{
id: 'ltd-30',
name: 'Promptables Life Time Deal 30',
credits: '30 Credits Per Month For Life',
price: '$89',
icon: FiZap,
link: 'https://www.paypal.com/ncp/payment/QDUK7N73ZHJDC',
popular: false,
savings: null
},
{
id: 'ltd-100',
name: 'Promptables Life Time Deal 100',
credits: '100 Credits Per Month For Life',
price: '$129',
icon: FiStar,
link: 'https://www.paypal.com/ncp/payment/P2WDFHYGM2UPN',
popular: true,
savings: '64% Savings Per Month'
},
{
id: 'ltd-unlimited',
name: 'Promptables Life Time Deal Unlimited',
credits: 'Unlimited Credits Per Month For Life',
price: '$259',
icon: FiTrendingUp,
link: 'https://www.paypal.com/ncp/payment/RVZX6CFNG64YW',
popular: false,
savings: '92% Savings Per Month'
} 
];

const features=[ 
'Access to All Tools',
'SPARK',
'CANVAS',
'BLUEPRINT',
'LENS',
'PATCH',
'FLOW',
'VIEW',
'GAMEDEV',
'Unlimited Github Uploads',
'Full Co-pilot Action',
'Access to Skool Group',
'All Future Upgrades'
];

return ( 
<div className="pricing-container"> 
<div className="pricing-header"> 
<h1 className="pricing-title"> 
Choose Your <span className="gradient-text">AI-Powered</span> Journey 
</h1> 
<p className="pricing-subtitle"> 
Unlock unlimited potential with our Life Time Deals. One payment,lifetime access. 
</p> 
</div> 

<div className="pricing-grid"> 
{pricingTiers.map((tier)=> ( 
<div key={tier.id} className={`pricing-card ${tier.popular ? 'popular' : ''}`}> 
{tier.popular && ( 
<div className="popular-badge"> 
<SafeIcon icon={FiStar} className="badge-icon" /> 
Popular Choice 
</div> 
)} 

<div className="card-header"> 
<div className="tier-icon"> 
<SafeIcon icon={tier.icon} className="icon" /> 
</div> 
<h3 className="tier-name">{tier.name}</h3> 
<div className="tier-type">Life Time Deal</div> 
</div> 

<div className="credits-section"> 
<div className="price-display">{tier.price}</div>
<div className="credits-amount">{tier.credits}</div> 
{tier.savings && (
<div className="savings-badge">{tier.savings}</div>
)}
</div> 

<div className="features-section"> 
<ul className="features-list"> 
{features.map((feature,index)=> ( 
<li key={index} className="feature-item"> 
<SafeIcon icon={FiCheck} className="check-icon" /> 
<span>{feature}</span> 
</li> 
))} 
</ul> 
</div> 

<div className="card-footer"> 
<a href={tier.link} className="buy-button" target="_blank" rel="noopener noreferrer" > 
<span className="button-text">Buy Now with PayPal</span> 
</a> 
</div> 
</div> 
))} 
</div> 

<div className="pricing-footer"> 
<p className="footer-text"> 
🚀 Lifetime access • No recurring fees 
</p> 
</div> 
</div> 
);
}

export default App;